import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import DashboardBuilder from "client_config/DashboardBuilder";
import CustomDropdown from "utils/CustomDropdown";
import { cloneDeep } from "lodash";

export default function Dashboard(props) {
  // Default dashboard to configure is the overall dashboard which will directly update the search_section's dashboard_order. If there is valid id passed through parameters the controller will update the relevant campaign group.
  let initialDashboards = [
    { name: "Video: Overall", id: 0, dashboardOrder: props.video_section.dashboard_order },
    ...props.video_section.campaign_groups.map((group) => ({ name: group.name, id: group.id, dashboardOrder: group.dashboard_order })),
  ];
  if (props.onboarding && props.videoDashboard) {
    initialDashboards = props.videoDashboard;
  }
  const [dashboards, setDashboards] = useState(initialDashboards);
  const [selectedDashboard, setSelectedDashboard] = useState(dashboards[0].name);
  const [selectedDashboardId, setSelectedDashboardId] = useState(dashboards[0].id);

  const copyFromOverall = () => {
    console.log(dashboards, selectedDashboard);
    const index = dashboards.findIndex((el) => el.name == selectedDashboard);
    let newDashboards = dashboards;
    newDashboards[index].dashboardOrder = cloneDeep(dashboards[0].dashboardOrder);
    setDashboards([...newDashboards]);
  };
  return (
    <>
      <Container fluid className="p-3">
        <Row>
          <Col>
            <div className="px-lg-5 pt-5 pr-0">
              <p className="f18 visby-bold text-info pb-4">Dashboard modules:</p>
              <p className="d-inline-block f16 primary pr-4 mb-2">Select View:</p>
              <CustomDropdown platformName="Video" dashboards={dashboards} selectedDashboardId={selectedDashboardId} setSelectedDashboardId={setSelectedDashboardId} selectedDashboard={selectedDashboard} setSelectedDashboard={setSelectedDashboard} />
              <div className="copy-btn d-md-inline-block d-block pl-md-3 pl-0">
                {dashboards.findIndex((el) => el.name == selectedDashboard) !== 0 && (
                  <Button style={{ paddingLeft: "10px", paddingRight: "10px", backgroundColor: "#3291c1" }} onClick={copyFromOverall}>
                    Copy dashboard setup from Overall
                  </Button>
                )}
              </div>
              <div className="pt-4">
                <p className="nunito-regular f-16 primary">
                  <strong>
                    Keep in mind you will need to configure the 'Campaign Groups' tab above before they will appear in the 'Select View' dropdown above!
                  </strong>
                  &nbsp; &nbsp;Check the box to enable/disable, and click and drag the left handleto reorder your dashboard. Click 'Display configuration' to
                  configure which metrics will show in each section.
                </p>
              </div>
            </div>
            <div></div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="pt-4 pb-5 px-0 px-lg-3">
              {dashboards
                .map((el) => {
                  if (!el.name.includes("Video: Overall")) {
                    let newDash = el;
                    let result = newDash.dashboardOrder.filter((dash) => {
                      return dash.name !== "campaignGroups";
                    });
                    el.dashboardOrder = result;
                  }
                  return el;
                })
                .map((dashboard, index) => {
                  let visible = dashboard.name == selectedDashboard;
                  return (
                    <div style={{ display: visible ? "block" : "none" }} key={index}>
                      <DashboardBuilder
                        service="video"
                        dashboard={dashboard}
                        videoSection={props.video_section}
                        enabledServices={props.enabled_services}
                        accountType={props.client_account.account_type}
                        onboarding={props.onboarding}
                        dashboards={dashboards}
                        setDashboard={props.setVideoDashboard}
                        currentDashboard={index}
                      />
                    </div>
                  );
                })}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
